__turbopack_context__.v({
  "btn": "button-module-scss-module__uyXhzq__btn",
  "eventButton": "button-module-scss-module__uyXhzq__eventButton",
  "whiteFocus": "button-module-scss-module__uyXhzq__whiteFocus",
  "wider": "button-module-scss-module__uyXhzq__wider",
  "wider-center": "button-module-scss-module__uyXhzq__wider-center",
});
